module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/icon_plus.b26c49d0.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/icon_plus.png
// module id = 3007
// module chunks = 11